interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  centered?: boolean
  label?: string
}

export default function Spinner({
  size = 'md',
  className = '',
  centered = false,
  label,
}: SpinnerProps) {
  const sizeClass = size === 'lg' ? 'spinner-lg' : size === 'sm' ? '' : ''
  const spinnerStyle =
    size === 'sm'
      ? { width: 16, height: 16, borderWidth: 2 }
      : undefined

  const spinner = (
    <div
      className={`spinner ${sizeClass} ${className}`}
      style={spinnerStyle}
      role="status"
      aria-label={label || 'Loading'}
    />
  )

  if (centered) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '3rem',
          gap: '0.75rem',
        }}
      >
        {spinner}
        {label && (
          <span
            style={{
              fontSize: '0.875rem',
              color: 'var(--color-text-secondary)',
            }}
          >
            {label}
          </span>
        )}
      </div>
    )
  }

  return spinner
}
